import { useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Button from '@mui/material/Button';
import { useGeoJson } from '../state/GeojsonContext';
import config from '../config';
import Element from './Element';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../state/SnackbarContext';
const createGeoJSONTemplate = require('../geojsonTemplate.js')


function Group({ id, group_data }) {
    const [expandElements, setExpandElements] = useState(false);
    const { setGeojsonData } = useGeoJson();
    const { text, showSnackbar } = useSnackbar();

    const handleButtonClick = (groupId) => {
        const url = `${config.serverUrl}/api/group_rate/${groupId}`;

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                const updatedData = data.map((item) => {
                    const geom_dict = JSON.parse(item.geom_geojson);
                    const geojson_geom_dict = createGeoJSONTemplate(geom_dict);
                    return { ...item, geom_geojson: geojson_geom_dict };
                });
                setGeojsonData(updatedData);
                showSnackbar(group_data.name);
            })
            .catch(error => {
                setGeojsonData(null);
                showSnackbar(group_data.name, error = true);
            });
    };

    const selectedGroup = text === group_data.name;

    return (
        <>
            <div className={"border-bottom"} style={{ backgroundColor: selectedGroup ? "#2c5a82" : (expandElements ? "#dadada" : "initial") }}>
                <Stack direction="row" spacing={1}>
                    <Button onClick={() => handleButtonClick(id)} style={{
                        textAlign: 'left',
                        justifyContent: "left",
                        textWrap: "wrap",
                        fontFamily: 'Open Sans, sans-serif',
                        fontWeight: '500',
                        fontSize: "12px",
                        color: selectedGroup ? "white" : "black",
                        padding: "3px 0px",
                        paddingLeft: "25px",
                        width: "100%"
                    }}>
                        {group_data.name}
                    </Button>
                    {Object.keys(group_data?.elements).length > 0 && (
                        <IconButton color="secondary" aria-label="expand elements" style={{ padding: "0px" }} onClick={() => setExpandElements(!expandElements)}>
                            {
                                Object.keys(group_data.elements).length > 0 && (!expandElements ?
                                    <ExpandMoreIcon style={{ color: selectedGroup ? "white" : "#2c5a82" }} /> : <ExpandLessIcon style={{ color: selectedGroup ? "white" : "#2c5a82" }} />)
                            }
                        </IconButton>
                    )}
                </Stack>
            </div>
            {expandElements && group_data.elements &&
                Object.entries(group_data.elements)
                    .sort((a, b) => a[1].name.localeCompare(b[1].name)).map(([key, item]) => (
                        <Element key={key} id={key} element_data={item} />
                    ))
            }
        </>
    );
}

export default Group;